import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import ReactTable from 'react-table';
import { actionCreators } from '../../store/modules/CouponCampaign';
import date from '../../utils/date';
import SaveButton from '../../controls/SaveButton';
import DeleteButton from '../../controls/DeleteButton';
import BackButton from '../../controls/BackButton';
import SelectField, { Convert } from '../../controls/SelectField';
import { CouponCampaignStatus } from '../../utils/enum';
import DateField from '../../controls/DateField';
import confirm, { NoCancel } from '../../utils/confirm';

class CouponCampaignEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id === 'new' ? null : Number(props.match.params.id),
    };
    this.form = React.createRef();
  }

  componentWillMount() {
    const { id } = this.state;
    const { requestGet, requestCouponTypes } = this.props;

    if (id) {
      requestGet(id);
    }

    requestCouponTypes(id);
  }

  componentWillReceiveProps(nextProps) {
    const {
      clearParse,
    } = this.props;

    if (nextProps.recipients && nextProps.recipients.length > 0) {
      if (this.form) {
        this.form.current.setFieldValue(
          'recipients',
          nextProps.recipients,
        );
      }
      clearParse();
    }
  }

  handleSaveAndPublish(values, errors) {
    const { id } = this.state;
    const {
      requestPost, requestPut,
    } = this.props;

    if (Object.keys(errors).length === 0 && errors.constructor === Object) {
      confirm('Sūtīt paziņojumu? Atcelt nebūs iespējams.').then(() => {
        if (id) {
          requestPut(id, values, true);
        } else {
          requestPost(values, true);
        }
      }, NoCancel);
    }
  }

  handleSave(values) {
    const { id } = this.state;
    const { requestPost, requestPut } = this.props;

    if (id) {
      requestPut(id, JSON.stringify(values), false);
    } else {
      requestPost(JSON.stringify(values), false);
    }
  }

  handleFileSelect(event) {
    const { requestParse } = this.props;

    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      requestParse(file);
      event.target.value = null;
    }
  }

  addAllRecipients() {
    const { requestRecipients } = this.props;

    confirm('Vai tiešām vēlaties pievienots visus? Tas var aizņemt vairākas minūtes.').then(() => requestRecipients());
  }

  testCouponTypeId2(expiry) {
    return (!this.parent.couponTypeId2 && !expiry) || (this.parent.couponTypeId2 && expiry);
  }

  testCouponTypeId3(expiry) {
    return (!this.parent.couponTypeId3 && !expiry) || (this.parent.couponTypeId3 && expiry);
  }

  testCouponTypeId4(expiry) {
    return (!this.parent.couponTypeId4 && !expiry) || (this.parent.couponTypeId4 && expiry);
  }

  testCouponTypeId5(expiry) {
    return (!this.parent.couponTypeId5 && !expiry) || (this.parent.couponTypeId5 && expiry);
  }

  render() {
    const {
      couponCampaign, couponTypes, requestDelete, requestStop, requestContinue,
    } = this.props;
    const { id } = this.state;

    const columns = [
      {
        id: 'holderId',
        Header: 'Saņēmēja ID',
        accessor: 'holderId',
        sortable: true,
        width: 120,
      },
      {
        id: 'googleToken',
        Header: 'Google Token',
        accessor: 'googleToken',
        sortable: false,
      },
      {
        id: 'appleToken',
        Header: 'Apple Token',
        accessor: 'appleToken',
        sortable: false,
      },
      // {
      //   id: 'error',
      //   Header: 'error',
      //   accessor: 'error',
      //   sortable: false,
      // },
    ];

    return (
      <Formik onSubmit={values => this.handleSave(values)}
        ref={this.form}
        enableReinitialize
        validationSchema={Yup.object().shape({
          name: Yup.string().required(),
          description: Yup.string().required(),
          couponTypeId: Yup.number().required(),
          couponExpiryOn: Yup.date().required(),
          couponTypeId2: Yup.number().nullable(),
          couponExpiryOn2: Yup.date().nullable().test('couponTypeId2', 'Both required', this.testCouponTypeId2),
          couponTypeId3: Yup.number().nullable(),
          couponExpiryOn3: Yup.date().nullable().test('couponTypeId3', 'Both required', this.testCouponTypeId3),
          couponTypeId4: Yup.number().nullable(),
          couponExpiryOn4: Yup.date().nullable().test('couponTypeId4', 'Both required', this.testCouponTypeId4),
          couponTypeId5: Yup.number().nullable(),
          couponExpiryOn5: Yup.date().nullable().test('couponTypeId5', 'Both required', this.testCouponTypeId5),
          scheduledOn: Yup.date().nullable(),
        })}
        initialValues={id && couponCampaign && couponCampaign.id === id ? couponCampaign
          : {
            name: '',
            description: '',
            couponTypeId: '',
            couponExpiryOn: '',
            couponTypeId2: '',
            couponExpiryOn2: '',
            couponTypeId3: '',
            couponExpiryOn3: '',
            couponTypeId4: '',
            couponExpiryOn4: '',
            couponTypeId5: '',
            couponExpiryOn5: '',
            scheduledOn: '',
            recipients: [],
            status: CouponCampaignStatus.New,
          }}
        render={({ values, errors, validateForm }) => (
          <Form>
            <div id="dataForm">
              <div className="row m-b-sm">
                <div className="col-md-12">
                  <span className="page-title hex-img">{id ? 'Kuponu Izsūtīšana' : 'Jauna Kuponu Izsūtīšana'}</span>
                  <div className="pageStyle">
                    <BackButton />
                    {id && (values.status === CouponCampaignStatus.Waiting || values.status === CouponCampaignStatus.Started) && (
                    <button type="button"
                      className="delete-btn"
                      onClick={() => requestStop(id)}>
                      <i className="glyphicon glyphicon-off" />
                      <div className="hover-text">Apturēt</div>
                    </button>
                    )}
                    {id && values.status !== CouponCampaignStatus.Waiting && values.status !== CouponCampaignStatus.Started && <DeleteButton onClick={() => requestDelete(id)} />}
                    {
                      (values.status === CouponCampaignStatus.New)
                      && (
                        <React.Fragment>
                          <SaveButton />
                          <button type="button"
                            className="active"
                            onClick={() => validateForm().then(err => this.handleSaveAndPublish(values, err))}>
                            <i className="glyphicon glyphicon-floppy-open" />
                            <div className="hover-text">Nosūtīt</div>
                          </button>
                        </React.Fragment>
                      )
                    }
                    {id && values.status === CouponCampaignStatus.Stopped && (
                    <button type="button"
                      className="delete-btn"
                      onClick={() => requestContinue(id)}>
                      <i className="glyphicon glyphicon-play" />
                      <div className="hover-text">Nosūtīt</div>
                    </button>
                    )}
                  </div>
                </div>
              </div>
              <div className="row p-l-md">
                <div className="col-md-12">
                  <div className="panel panel-default">
                    <div className="panel-heading" />
                    <div className="panel-body" id="scroller">
                      <div className="col-sm-9">
                        <div className="row">
                          <div className="col-lg-7 col-md-7 col-sm-7 col-xs-12">
                            <div className="form-group form-group-lg label-static is-empty">
                              <label htmlFor="name" className="control-label font-bold">
                                Nosaukums (optimāli līdz 50 simboliem)
                                <Field id="name"
                                  name="name"
                                  autoFocus
                                  className={errors.name ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                          <div className="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                            <div className="form-group form-group-lg">
                              <label htmlFor="scheduledOn" className="control-label font-bold">
                                Plānotais izpildes laiks
                                <Field id="scheduledOn"
                                  name="scheduledOn"
                                  component={DateField}
                                  isClearable
                                  minDate={values.createdOn ? `${new Date(values.createdOn).toISOString().split('T')[0]}T00:00` : `${new Date().toISOString().split('T')[0]}T00:00`}
                                  className={errors.scheduledOn ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="form-group form-group-lg label-static is-empty">
                              <label htmlFor="description" className="control-label font-bold">
                                Teksts  (optimāli līdz 110 simboliem)
                                <Field id="description"
                                  name="description"
                                  component="textarea"
                                  rows="2"
                                  className={errors.description ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-7 col-md-7 col-sm-7 col-xs-12">
                            <div className="form-group form-group-lg label-static is-empty">
                              <label htmlFor="couponTypeId" className="control-label font-bold">
                                Kupons 1
                                <Field id="couponTypeId"
                                  name="couponTypeId"
                                  component={SelectField}
                                  options={Convert(couponTypes)}
                                  className={errors.couponTypeId ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                          <div className="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                            <div className="form-group form-group-lg">
                              <label htmlFor="couponExpiryOn" className="control-label font-bold">
                                  Derīguma termiņš
                                <Field id="couponExpiryOn"
                                  name="couponExpiryOn"
                                  component={DateField}
                                  isClearable
                                  isDateOnly
                                  minDate={values.createdOn ? new Date(values.createdOn).toISOString().split('T')[0] : new Date().toISOString().split('T')[0]}
                                  className={errors.couponExpiryOn ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-7 col-md-7 col-sm-7 col-xs-12">
                            <div className="form-group form-group-lg label-static is-empty">
                              <label htmlFor="couponTypeId2" className="control-label font-bold">
                                Kupons 2
                                <Field id="couponTypeId2"
                                  name="couponTypeId2"
                                  component={SelectField}
                                  options={Convert(couponTypes)}
                                  className={errors.couponTypeId2 ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                          <div className="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                            <div className="form-group form-group-lg">
                              <label htmlFor="couponExpiryOn2" className="control-label font-bold">
                                  Derīguma termiņš
                                <Field id="couponExpiryOn2"
                                  name="couponExpiryOn2"
                                  component={DateField}
                                  isClearable
                                  isDateOnly
                                  minDate={values.createdOn ? new Date(values.createdOn).toISOString().split('T')[0] : new Date().toISOString().split('T')[0]}
                                  className={errors.couponExpiryOn2 ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-7 col-md-7 col-sm-7 col-xs-12">
                            <div className="form-group form-group-lg label-static is-empty">
                              <label htmlFor="couponTypeId3" className="control-label font-bold">
                                Kupons 3
                                <Field id="couponTypeId3"
                                  name="couponTypeId3"
                                  component={SelectField}
                                  options={Convert(couponTypes)}
                                  className={errors.couponTypeId3 ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                          <div className="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                            <div className="form-group form-group-lg">
                              <label htmlFor="couponExpiryOn3" className="control-label font-bold">
                                  Derīguma termiņš
                                <Field id="couponExpiryOn3"
                                  name="couponExpiryOn3"
                                  component={DateField}
                                  isClearable
                                  isDateOnly
                                  minDate={values.createdOn ? new Date(values.createdOn).toISOString().split('T')[0] : new Date().toISOString().split('T')[0]}
                                  className={errors.couponExpiryOn3 ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-7 col-md-7 col-sm-7 col-xs-12">
                            <div className="form-group form-group-lg label-static is-empty">
                              <label htmlFor="couponTypeId4" className="control-label font-bold">
                                Kupons 4
                                <Field id="couponTypeId4"
                                  name="couponTypeId4"
                                  component={SelectField}
                                  options={Convert(couponTypes)}
                                  className={errors.couponTypeId4 ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                          <div className="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                            <div className="form-group form-group-lg">
                              <label htmlFor="couponExpiryOn4" className="control-label font-bold">
                                  Derīguma termiņš
                                <Field id="couponExpiryOn4"
                                  name="couponExpiryOn4"
                                  component={DateField}
                                  isClearable
                                  isDateOnly
                                  minDate={values.createdOn ? new Date(values.createdOn).toISOString().split('T')[0] : new Date().toISOString().split('T')[0]}
                                  className={errors.couponExpiryOn4 ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-7 col-md-7 col-sm-7 col-xs-12">
                            <div className="form-group form-group-lg label-static is-empty">
                              <label htmlFor="couponTypeId5" className="control-label font-bold">
                                Kupons 5
                                <Field id="couponTypeId5"
                                  name="couponTypeId5"
                                  component={SelectField}
                                  options={Convert(couponTypes)}
                                  className={errors.couponTypeId5 ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                          <div className="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                            <div className="form-group form-group-lg">
                              <label htmlFor="couponExpiryOn5" className="control-label font-bold">
                                  Derīguma termiņš
                                <Field id="couponExpiryOn5"
                                  name="couponExpiryOn5"
                                  component={DateField}
                                  isClearable
                                  isDateOnly
                                  minDate={values.createdOn ? new Date(values.createdOn).toISOString().split('T')[0] : new Date().toISOString().split('T')[0]}
                                  className={errors.couponExpiryOn5 ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="form-group form-group-lg">
                              <label htmlFor="scheduledOn" className="control-label font-bold">
                                Saņēmēji
                                <label htmlFor="file-upload" className="form-control custom-file-upload coupon-campaign">
                                  Pievienot failu
                                  <input type="file"
                                    id="file-upload"
                                    accept=".csv"
                                    onChange={event => this.handleFileSelect(event)} />
                                </label>
                              </label>
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="form-group form-group-lg">
                              <label htmlFor="scheduledOn" className="control-label font-bold">
                                &nbsp;
                                <button type="button" className="form-control custom-file-upload coupon-campaign"
                                  onClick={() => this.addAllRecipients()}>
                                Pievienot visus
                                </button>
                              </label>
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="form-group form-group-lg">
                              <label htmlFor="scheduledOn" className="control-label font-bold">
                                &nbsp;
                                <button type="button" className="form-control custom-file-upload coupon-campaign"
                                  onClick={() => this.form.current.setFieldValue('recipients', [])}>
                                Dzēst visus
                                </button>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row coupon-campaign-recipients">
                          <ReactTable data={values.recipients}
                            previousText="Iepriekšējais"
                            nextText="Nākamais"
                            pageText="Lapa"
                            ofText="no"
                            rowsText="ieraksti"
                            columns={columns}
                            resizable={false}
                            multiSort={false}
                            defaultSorted={[
                              {
                                id: 'holderId',
                                desc: false,
                              },
                            ]}
                            noDataText="Nav ierakstu"
                            minRows={4}
                            showPagination />
                        </div>
                      </div>
                      {id
                        && couponCampaign && (
                          <div className="col-sm-3 form-additional-info">
                            <label>
                              Izveidots
                              <div>{date.long(couponCampaign.createdOn)}</div>
                            </label>
                            <label>
                              Izsūtīšana
                              <div>{couponCampaign.pushNotificationCount} kopā</div>
                              <div>{couponCampaign.successfulPushNotificationCount} veiksmīgi</div>
                              <div>{couponCampaign.failedPushNotificationCount} kļūdaini</div>
                            </label>
                            <label>
                              Status
                              <div>{CouponCampaignStatus[couponCampaign.status]}</div>
                              <div className="campaign-status">{couponCampaign.statusDescription}</div>
                            </label>
                          </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )} />
    );
  }
}

CouponCampaignEdit.propTypes = {
  couponCampaign: PropTypes.shape({ id: PropTypes.number, name: PropTypes.string }),
  requestGet: PropTypes.func.isRequired,
  requestPost: PropTypes.func.isRequired,
  requestPut: PropTypes.func.isRequired,
  requestDelete: PropTypes.func.isRequired,
  requestStop: PropTypes.func.isRequired,
  requestContinue: PropTypes.func.isRequired,
  requestCouponTypes: PropTypes.func.isRequired,
  requestParse: PropTypes.func.isRequired,
  clearParse: PropTypes.func.isRequired,
  requestRecipients: PropTypes.func.isRequired,
  match: PropTypes.shape().isRequired,
  couponTypes: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number, name: PropTypes.string })).isRequired,
  recipients: PropTypes.arrayOf(PropTypes.shape({ })).isRequired,
};

CouponCampaignEdit.defaultProps = {
  couponCampaign: null,
};

export default connect(
  state => ({
    couponCampaign: state.couponCampaign.current,
    couponTypes: state.couponCampaign.couponTypes,
    recipients: state.couponCampaign.recipients,
  }),
  dispatch => bindActionCreators(actionCreators, dispatch),
)(CouponCampaignEdit);



// WEBPACK FOOTER //
// ./src/components/couponCampaign/Edit.jsx